import React from 'react';

import {  Header, About, Opportunities, Blog, Contact , Footer} from './containers';
import {  Navbar } from './components';

import './App.css';

const App = () => (
  <div className="App">
    <div className="gradient__bg">
      <Navbar />
      <Header />
    </div>
    <About />
    <Opportunities />
    <Blog />
    <Contact/>
    <Footer /> 
    {/* <Brand />
    <WhatGPT3 />
    <Features />
    <Possibility />
    <CTA />
  
    <Footer /> */}
  </div>
);

export default App;
